import { inject as t } from "vue";
import { toastKey as o } from "./design-system.es7.js";
function a() {
  return t(o);
}
export {
  a as default
};
//# sourceMappingURL=design-system.es6.js.map
